import type { DateRange } from "@/types/common/dates";
import { Calendar } from "@elaniintc/goes-design-system";
import { useEffect, useState } from "react";
import FilterDate from "./FilterDate";

interface FilterStateProps {
  title: string;
  initialDate?: Date | undefined;
  endDate?: Date | undefined;
  shouldDisabledFutureDates?: boolean;
  onDatesChange: (
    type: string,
    newDate: Date | undefined,
    toDate?: Date | undefined,
  ) => void;
}
export default function FilterDateRange({
  title,
  initialDate = undefined,
  endDate = undefined,
  shouldDisabledFutureDates,
  onDatesChange,
}: FilterStateProps) {
  const [dateRange, setDateRange] = useState<DateRange>();

  useEffect(() => {
    setDateRange({
      from: initialDate,
      to: endDate,
    });
  }, [initialDate, endDate]);

  const handleChangeRange = (range: DateRange | undefined) => {
    onDatesChange("range", range?.from, range?.to);
  };
  return (
    <div className="flex flex-col space-y-6 p-6">
      <div className="flex justify-between">
        <h5 className="text-heading text-xl font-semibold">{title}</h5>
      </div>
      <div className="flex flex-col space-y-0.5">
        <div className="space-y-2">
          <div className="flex space-x-2.5">
            <FilterDate
              date={initialDate}
              title="Desde"
              onChangeDate={(date) => onDatesChange("desde", date)}
              shouldDisabledFutureDates={shouldDisabledFutureDates}
            />
            <FilterDate
              date={endDate}
              title="Hasta"
              onChangeDate={(date) => onDatesChange("hasta", date)}
              shouldDisabledFutureDates={shouldDisabledFutureDates}
              disabled={!initialDate}
            />
          </div>
          <Calendar
            aria-label="rango"
            mode="range"
            selected={dateRange}
            disabled={
              shouldDisabledFutureDates ? { after: new Date() } : undefined
            }
            onSelect={handleChangeRange}
            defaultMonth={initialDate ? initialDate : new Date()}
            className="w-full bg-neutral-foreground! max-w-full mx-0"
          />
        </div>
      </div>
    </div>
  );
}
